import {createMap} from "./src/utils/mapUtils";
window.addEventListener('load', function(){
    const { featureGroups, greyscale } = window.__mapConfig__;
    createMap('map', featureGroups, greyscale, window.__mapConfig__?.zoom ?? null);
});

